import React from 'react';
import { ArrowUpRight, FileText } from 'lucide-react';
import { Skeleton } from '@/ui';

// Loading / not-found / footer presentational components for the public
// report portal. Lifted out of ClientPortal.tsx during the 2026-05-01 split.

export const PortalSkeleton: React.FC = () => (
  <div className="min-h-screen bg-surface-0">
    <div className="h-1 bg-brand" />
    <div className="bg-surface-1 border-b border-border-subtle">
      <div className="max-w-[860px] mx-auto px-4 sm:px-6 py-12">
        <Skeleton width="w-32" height="h-8" className="mb-6" />
        <Skeleton width="w-24" height="h-3" className="mb-3" />
        <Skeleton width="w-3/4" height="h-12" className="mb-4" />
        <Skeleton width="w-1/2" height="h-5" />
      </div>
    </div>
    <div className="max-w-[860px] mx-auto px-4 sm:px-6 py-8">
      <div className="grid grid-cols-2 gap-3 mb-6">
        {[0, 1].map(i => <Skeleton key={i} width="w-full" height="h-28" />)}
      </div>
      <Skeleton width="w-full" height="h-64" />
    </div>
  </div>
);

export const PortalNotFound: React.FC<{ message: string | null }> = ({ message }) => (
  <div className="min-h-screen flex items-center justify-center bg-surface-0">
    <div className="max-w-md text-center px-6">
      <div className="h-14 w-14 rounded-2xl bg-surface-2 flex items-center justify-center mx-auto mb-4 text-ink-subtle">
        <FileText className="h-6 w-6" />
      </div>
      <h1 className="font-display text-display-sm text-ink" style={{ fontVariationSettings: "'opsz' 144, 'SOFT' 40" }}>
        Report not found
      </h1>
      <p className="mt-2 text-body-md text-ink-subtle">
        {message || 'This report is no longer available. Please check the link and try again.'}
      </p>
    </div>
  </div>
);

export const BrandFooter: React.FC = () => (
  <footer className="mt-16 pb-10">
    <div className="max-w-[860px] mx-auto px-4 sm:px-6">
      <div className="pt-8 border-t border-border-subtle flex items-center justify-between gap-4 flex-wrap">
        <p className="text-caption text-ink-faint">
          Delivered with{' '}
          <a
            href="https://flowspect.app"
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-ink-subtle hover:text-ink underline-offset-2 hover:underline inline-flex items-center gap-1"
          >
            Flowspect <ArrowUpRight className="h-3 w-3" />
          </a>
        </p>
        <p className="text-caption text-ink-faint">
          © {new Date().getFullYear()} · All findings reflect the inspector's opinion at the time of inspection.
        </p>
      </div>
    </div>
  </footer>
);
